<template lang="pug">
	section.section.phone-section.border-bottom-section
		.section-content
			.columns.is-valigned-end
				.column.is-narrow.column-app-phone2
					img.block(src="/img/phone-it.png" :alt="$t('alt.app')" draggable="false")
				.column.column-app-phone1
					p.subtitle.no-line-break-mobile
						| {{ $t('home.subtitle_l1') }}

					.alert-box
						.has-text-centered
							.columns.is-mobile.is-centered.is-vcentered.is-multiline.columns-no-padding-vertical.margin-top-xs
								.column.is-narrow
									| {{ $t('home.section_intro.app1') }}
								.column.is-narrow.no-padding-left
									img(src="/icon.png" alt="" draggable="false" style="width:2.2rem; display:block;")
								.column.is-narrow.no-padding-left
									strong {{ $t('home.section_intro.app2') }}
								.column.is-narrow.no-padding-left
									| {{ $t('home.section_intro.app3') }}
							.app-container.margin-top-xs
								a(href='https://play.google.com/store/apps/details?id=com.fitnessdadivano.app' target='_blank' style="max-width:140px")
									img(src="/img/google_play_badge.svg", alt="Android", title="Android")
								a(href='https://itunes.apple.com/it/app/id1531130588?mt=8' target='_blank' style="max-width:140px")
									img(src="/img/app_store_badge.svg", alt="iOS", title="iOS")
</template>

<script>
export default {
	name : 'SectionIntro'
}
</script>
